// extracted by mini-css-extract-plugin
export default {"post-body-param-evaluated":"BodyParam_post-body-param-evaluated__r4RHY","beautify-btn":"BodyParam_beautify-btn__CEpDp","error-tips":"BodyParam_error-tips__Y6MGt"};